const initialState = {
  requestingFetchLogisticsServiceTypes: false,
  successfulFetchLogisticsServiceTypes: false,
  errorFetchLogisticsServiceTypes: false,
  logisticsServiceTypes: [],
};

const LogisticsServiceTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_LOGISTICS_SERVICE_TYPES_REQUESTING":
      return {
        ...state,
        requestingFetchLogisticsServiceTypes: true,
        successfulFetchLogisticsServiceTypes: false,
        errorFetchLogisticsServiceTypes: false,
      };
    case "FETCH_LOGISTICS_SERVICE_TYPES_SUCCESS":
      return {
        ...state,
        requestingFetchLogisticsServiceTypes: false,
        successfulFetchLogisticsServiceTypes: true,
        errorFetchLogisticsServiceTypes: false,
        logisticsServiceTypes: action.value,
      };
    case "FETCH_LOGISTICS_SERVICE_TYPES_ERROR":
      return {
        ...state,
        requestingFetchLogisticsServiceTypes: false,
        successfulFetchLogisticsServiceTypes: false,
        errorFetchLogisticsServiceTypes: true,
      };
    default:
      return state;
  }
};

export default LogisticsServiceTypeReducer;
